export const gridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
};

export const gridColumns = [
  {
    headerName: 'Award',
    field: 'position',
    minWidth: 300,
    sort: 'asc',
    valueGetter: (params) => params.data.award.name,
  },
  {
    headerName: 'Nominee',
    field: 'nominee',
    flex: 1,
    valueGetter: (params) => {
      const nomination = params.data;

      return nomination.identification;
    },
  },
  {
    headerName: 'Email',
    field: 'email',
    valueGetter: (params) => params.data.nominee_email,
  },
  {
    headerName: 'Status',
    field: 'status',
    valueGetter: (params) => params.data.status.labelNominator,
    maxWidth: 180,
  },
  {
    headerName: 'Date',
    field: 'date',
    maxWidth: 120,
  },
];
